import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getMyMenuOrdersRequest = (
  token,
  startDate,
  endDate,
  selectedRestaurant
) => {
  const organizationId = localStorage.getItem("organizationId");

  const url =
    apiURl +
    "Orders/getOrdersByDate?organizationId=" +
    organizationId +
    "&restaurantId=" +
    selectedRestaurant +
    "&startDate=" +
    startDate +
    "&endDate=" +
    endDate;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { getMyMenuOrdersRequest };
